import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { gray5, gray60, tertiaryButtonBackgroundColor } from '../../../constants/colors';
import { regularXs } from '../../../constants/location';
import { copyBackupCodesToClipboard, downloadBackupCodesPdf } from './backupCodesFile';

interface Props {
  codes: string[];
  email: string;
  /** コピー / ダウンロードのいずれかを実施したときに true で通知 */
  onSavedChange: (saved: boolean) => void;
}

const styles = {
  codeList: {
    backgroundColor: gray5,
    borderRadius: '4px',
    display: 'grid',
    fontFamily: 'monospace',
    fontSize: '16px',
    gap: '8px',
    gridTemplateColumns: '1fr 1fr',
    marginBottom: '16px',
    padding: '16px',
  },
  caption: {
    ...regularXs,
    color: gray60,
    marginTop: '8px',
  },
  actionButton: {
    height: '44px',
    minWidth: '140px',
  },
};

/**
 * MFA バックアップコードの表示・保存部品（#2984）。
 * 一覧表示と「コピー / PDF ダウンロード」を提供する（登録・再発行ダイアログで共用）。
 */
const MfaBackupCodesView: React.FC<Props> = ({ codes, email, onSavedChange }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (): Promise<void> => {
    await copyBackupCodesToClipboard(codes);
    setCopied(true);
    onSavedChange(true);
  };

  const handleDownload = async (): Promise<void> => {
    await downloadBackupCodesPdf(codes, email);
    onSavedChange(true);
  };

  return (
    <Box>
      <Box sx={styles.codeList}>
        {codes.map(code => (
          <Typography key={code} component="span">
            {code}
          </Typography>
        ))}
      </Box>
      <Box sx={{ display: 'flex', gap: '12px' }}>
        <Button onClick={handleCopy} sx={[tertiaryButtonBackgroundColor, styles.actionButton]}>
          {copied ? 'コピーしました' : 'コピーする'}
        </Button>
        <Button onClick={handleDownload} sx={[tertiaryButtonBackgroundColor, styles.actionButton]}>
          PDFでダウンロード
        </Button>
      </Box>
      <Typography sx={styles.caption}>
        ※ 各コードは1回のみ使用できます。このコードは後から再表示できません（再発行は可能です）。
      </Typography>
    </Box>
  );
};

export default MfaBackupCodesView;
